/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import { BaseApiModel } from './BaseApiModel';

export class PreProcessSettings extends BaseApiModel {
  contractId: number;
  percentageOddSpeed: number;
  addOcrPlate: boolean;
  lotGenerationId?: number;
  verifyNoMetrologicalCalibrationValidity: boolean;
  whitelistReasonId: number;
  plateNotFoundReasonId: number;
  incompleteVehicleDataReasonId: number;
  requiredFields: string[];
  vehicleDataSearch: VehicleDataSearchTypes;
  quarantine: {
    maxPeriod: number;
    reasonId: number;
    refused: string;
    validateOddSpeed: boolean;
  };
  imageEdit: {
    hideImageEdit: boolean;
    blur: boolean;
    clip: boolean;
    clipPosition: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
  };
  violationLimit: Array<{
    regulationId: string;
    reasonId: string;
    classificationIds: number[];
    periods: Array<{
      time: number;
      startTime: string;
      endTime: string;
    }>;
  }>;
  violationSteps: {
    firstStep: string;
    triage: {
      regulationIds: Array<string>;
      accepted: string;
      refused: string;
    };
    typing: {
      ocrSkip: boolean;
      accepted: string;
      refused: string;
    };
    doubleTyping: {
      accepted: string;
      refused: string;
    };
    verifyValid: {
      accepted: string;
      refused: string;
      changesPermited: boolean;
    };
    verifyInvalid: {
      accepted: string;
      refused: string;
      changesPermited: boolean;
    };
    validate: {
      nextStep: string;
    };
    lotAttribution: {
      lotStep: string;
    };
  };
  violationStepOrder: string[];
  lotSteps: {
    internalAudit?: {
      accepted: string;
      refused: string;
    };
    revision?: {
      nextStep: string;
    };
    externalAudit?: {
      nextStep: string;
    };
    waitReturn?: {
      nextStep: string;
    };
    export?: {
      nextStep: string;
    };
    externalExport?: {
      nextStep: string;
    };
    generationLot?: {
      nextStep: string;
    };
  };
  audit: {
    allowAuditInvalidateLot: boolean;
    enabledViolationDiscord: boolean;
    acceptableQualityLevel: number;
    requiredFieldsAudit: string[];
    fieldsToLotRefused: Array<{
      violationStatus: string;
      reasonIds: Array<string>;
      vehicleFields: Array<string>;
    }>;
    enabledLotGenerationAudit: boolean;
    enabledSamplingPlan: boolean;
    lotGeneration: {
      stopAttribution?: boolean;
      namePattern?: string;
      pathPattern?: string;
      autoGeneration: Array<{
        lotControlId: string;
        generationLimit: number;
        namePattern: string;
        pathPattern: string;
        pathPatternImport: string;
        period: number;
        cron: string;
        maxAmountViolation: number;
        regulationIds: Array<string>;
        laneIds: Array<string>;
        reasonIds: Array<string>;
        equipmentModelIds: Array<string>;
        violationStatus: ViolationStatus[];
        isSpecial: boolean;
        oddSpeed: boolean;
      }>;
    };
  };
  lotStepOrder: string[];
  violationAgeAlert: number;
  lotAgeAlert: number;
  changeBrandModelForClientBrand: boolean;
  createdAt: Date;
  modifiedAt: Date;
  enabledRestrictionZone: boolean;
  enabledAlertOddSpeed: boolean;
  allowInputNotFoundVehicle: boolean;
  maxVideoTime: number;
  observation: string;
  manageVideoTime: boolean;
  enabledViolationStandBy: boolean;
  maxPeriodViolationStandBy: number;
  enabledReportOCR: boolean;
  allowedViewViolationsOCRFailed: boolean;
  userGroupIds: Array<string>;
  violationExpired: {
    invalidateExpiredViolation: boolean;
    maxPeriod: number;
    refused: string;
    reasonId: number;
  };
  enabledWhiteList: boolean;
  enabledVehicleForeign: boolean;
  requiredFieldsVehicleForeign: string[];
  weightClass: {
    enabled: boolean;
    regulationIds: Array<string>;
    laneIds: Array<string>;
  };
}

export enum VehicleDataSearchTypes {
  disabled = 'disabled',
  sppInternal = 'SPP-Base Interna',
  sppCompom = 'SPP-COPOM',
  sppAntt = 'SPP-ANTT',
  sppMjsp = 'SPP-MJSP',
  sppSerpro = 'SPP-SERPRO'
}

export enum ViolationStatus {
  valid = 'valid',
  invalid = 'invalid'
}

export enum VehicleRequiredFields {
  colorCode = 'colorCode',
  typeCode = 'typeCode',
  plate = 'plate',
  classificationCode = 'classificationCode',
  year = 'year',
  brandModelCode = 'brandModelCode',
  categoryCode = 'categoryCode',
  modelYear = 'modelYear',
  chassis = 'chassis',
  uf = 'uf',
}

export enum Steps {
  triage = 'triage',
  typing = 'typing',
  verifyValid = 'verifyValid',
  verifyInvalid = 'verifyInvalid',
  validate = 'validate',
  lotAttribution = 'lotAttribution'
}

export enum LotSteps {
  export = 'export',
  externalExport = 'externalExport',
  internalAudit = 'internalAudit',
  revision = 'revision',
  externalAudit = 'externalAudit',
  waitReturn = 'waitReturn',
  serialNumberGeneration = 'serialNumberGeneration',
  generationLot = 'generationLot',
  end = 'end',
  done = 'done'
}
